var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.834,
    height: 16.5,
    viewBox: "0 0 13.834 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield-plus",
    transform: "translate(-1.75 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80396",
    "data-name": "Path 80396",
    d: "M-1433.956-709.579c-.266-.118-6.545-2.95-6.545-8.171v-3.412a3.573,3.573,0,0,1,2.451-3.4l4.177-1.393a.928.928,0,0,1,.289-.047.929.929,0,0,1,.29.047l4.177,1.393a3.573,3.573,0,0,1,2.451,3.4v3.411c0,5.221-6.278,8.053-6.546,8.171a.911.911,0,0,1-.371.078A.922.922,0,0,1-1433.956-709.579Zm-3.514-13.243a1.747,1.747,0,0,0-1.2,1.66v3.412a5.913,5.913,0,0,0,2.166,4.268,13.661,13.661,0,0,0,2.916,2.043,13.687,13.687,0,0,0,2.916-2.047,5.913,5.913,0,0,0,2.168-4.263v-3.412a1.748,1.748,0,0,0-1.2-1.66l-3.887-1.3Z",
    transform: "translate(1442.25 725.75)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80337",
    "data-name": "Path 80337",
    d: "M12.667,9H11.333V7.667a.667.667,0,1,0-1.333,0V9H8.667a.667.667,0,0,0,0,1.333H10v1.333a.667.667,0,1,0,1.333,0V10.333h1.333a.667.667,0,0,0,0-1.333Z",
    transform: "translate(-2 -2.333)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldPlus);
export default __webpack_public_path__ + "static/media/shield-plus.aad68679776064e94b37eb261a71ab76.svg";
export { ForwardRef as ReactComponent };